<div class="drop-down">
    <div class="selected">
      <span>Please select</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M4.37402 7.49805L9.99902 13.123L15.624 7.49805"
          stroke="black"
          stroke-width="1.97017"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="options">
      <ul>
        <li>
          <div class="item">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
            >
              <g clip-path="url(#clip0_2152_10732)">
                <path
                  d="M15.4874 8.96171C23.4188 8.96171 22.8328 8.96004 22.955 8.96477C22.8812 8.68192 22.7332 8.4239 22.5263 8.21736L20.3518 6.04286C19.8819 5.57293 19.1605 5.43631 18.5565 5.70309C18.2322 5.84639 17.8457 5.77407 17.5948 5.52321C17.344 5.2724 17.2717 4.88593 17.4149 4.56161C17.6817 3.95774 17.5452 3.23623 17.0751 2.76626L14.9007 0.591754C14.2561 -0.052696 13.2075 -0.0527438 12.563 0.591754L9.84242 3.31229L15.4874 8.96171ZM8.82842 4.32633L4.19304 8.96171H13.4594C13.4426 8.94489 13.088 8.58987 8.82842 4.32633ZM23.4585 16.6337C24.0741 16.3954 24.4878 15.7886 24.4878 15.1239V12.0488C24.4878 11.1373 23.7462 10.3957 22.8347 10.3957H19.4687V24.486H22.8347C23.7462 24.486 24.4878 23.7444 24.4878 22.833V19.7578C24.4878 19.0932 24.0742 18.4864 23.4586 18.2481C23.1279 18.12 22.9057 17.7956 22.9057 17.4408C22.9057 17.0861 23.1279 16.7617 23.4585 16.6337ZM0.109375 12.0488V15.1239C0.109375 15.7886 0.522995 16.3954 1.13857 16.6336C1.46926 16.7617 1.69139 17.0861 1.69139 17.4408C1.69139 17.7956 1.46921 18.12 1.13853 18.2481C0.522947 18.4864 0.109375 19.0932 0.109375 19.7578V22.833C0.109375 23.7444 0.850956 24.486 1.76242 24.486H18.0347V10.3957H1.76242C0.850956 10.3957 0.109375 11.1373 0.109375 12.0488ZM5.12845 13.7308H15.8836V15.1649H5.12845V13.7308ZM5.12845 16.5989H15.8836V18.0329H5.12845V16.5989ZM5.12845 19.4669H15.8836V20.901H5.12845V19.4669Z"
                  fill="black"
                />
              </g>
              <defs>
                <clipPath id="clip0_2152_10732">
                  <rect
                    width="24.3784"
                    height="24.3784"
                    fill="white"
                    transform="translate(0.109375 0.108398)"
                  />
                </clipPath>
              </defs>
            </svg>
            Ticket+
          </div>
          <div class="item">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
            >
              <path
                d="M22.84 8.12257L19.3509 11.6117L19.36 11.6423L22.0097 21.3954C22.0551 21.6085 22.0495 21.8293 21.9936 22.0399C21.9376 22.2504 21.8328 22.4448 21.6877 22.6073L20.8131 23.4819C20.7565 23.5479 20.6842 23.5987 20.6029 23.6294C20.5215 23.6601 20.4338 23.6698 20.3477 23.6577C20.2616 23.6455 20.1799 23.6118 20.1103 23.5598C20.0406 23.5077 19.9852 23.4389 19.9492 23.3598L16.3654 16.8729L15.2283 15.7343L12.2214 18.7411C11.8768 19.0487 11.4916 19.3075 11.0767 19.5104L11.7483 21.719C11.7992 21.9295 11.7982 22.1493 11.7453 22.3594C11.6924 22.5695 11.5892 22.7635 11.4445 22.9248L11.1774 23.1934C11.0411 23.3287 10.8567 23.4047 10.6646 23.4047C10.4725 23.4047 10.2881 23.3287 10.1518 23.1934L8.56439 21.6076L8.53692 21.577L7.33418 20.3774L7.30365 20.3468L5.71934 18.761C5.584 18.6246 5.50806 18.4403 5.50806 18.2481C5.50806 18.056 5.584 17.8717 5.71934 17.7353L5.98797 17.4667C6.14954 17.3226 6.34371 17.2199 6.55376 17.1675C6.76382 17.1152 6.98345 17.1146 7.19376 17.166L9.40234 17.8345C9.60542 17.4197 9.86424 17.0345 10.1716 16.6898L13.1784 13.6829L12.0398 12.5474L5.55297 8.96357C5.47384 8.92753 5.40506 8.87213 5.353 8.80248C5.30093 8.73283 5.26726 8.65119 5.25509 8.56509C5.24292 8.47899 5.25265 8.39122 5.28337 8.30987C5.31409 8.22852 5.36482 8.15623 5.43086 8.09967L6.30544 7.22509C6.46798 7.08004 6.66239 6.97529 6.87293 6.91934C7.08348 6.86339 7.30424 6.85781 7.51734 6.90304L17.2705 9.55272L17.301 9.56188L20.7902 6.07272C21.3549 5.50493 23.2643 4.51588 23.8321 5.08062C24.3969 5.64841 23.4063 7.5563 22.84 8.12257Z"
                fill="black"
              />
            </svg>
            Flight +
          </div>
          <div class="item">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="29"
              height="33"
              viewBox="0 0 29 33"
              fill="none"
            >
              <path
                d="M3.25781 8.90332V24.6533C3.25781 24.9517 3.37634 25.2378 3.58732 25.4488C3.7983 25.6598 4.08444 25.7783 4.38281 25.7783H15.6328V7.77832H4.38281C4.08444 7.77832 3.7983 7.89685 3.58732 8.10782C3.37634 8.3188 3.25781 8.60495 3.25781 8.90332ZM6.63281 11.1533H12.2578V13.4033H6.63281V11.1533ZM6.63281 15.6533H12.2578V17.9033H6.63281V15.6533ZM6.63281 20.1533H12.2578V22.4033H6.63281V20.1533ZM25.7578 4.40332V24.6533C25.7578 24.9517 25.6393 25.2378 25.4283 25.4488C25.2173 25.6598 24.9312 25.7783 24.6328 25.7783H17.8828V5.52832H12.2578V4.40332C12.2578 4.10495 12.3763 3.8188 12.5873 3.60783C12.7983 3.39685 13.0844 3.27832 13.3828 3.27832H24.6328C24.9312 3.27832 25.2173 3.39685 25.4283 3.60783C25.6393 3.8188 25.7578 4.10495 25.7578 4.40332Z"
                fill="black"
              />
            </svg>
            Hotel
          </div>
        </li>
        <li>
          <div class="item">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
            >
              <path
                d="M22.84 8.12257L19.3509 11.6117L19.36 11.6423L22.0097 21.3954C22.0551 21.6085 22.0495 21.8293 21.9936 22.0399C21.9376 22.2504 21.8328 22.4448 21.6877 22.6073L20.8131 23.4819C20.7565 23.5479 20.6842 23.5987 20.6029 23.6294C20.5215 23.6601 20.4338 23.6698 20.3477 23.6577C20.2616 23.6455 20.1799 23.6118 20.1103 23.5598C20.0406 23.5077 19.9852 23.4389 19.9492 23.3598L16.3654 16.8729L15.2283 15.7343L12.2214 18.7411C11.8768 19.0487 11.4916 19.3075 11.0767 19.5104L11.7483 21.719C11.7992 21.9295 11.7982 22.1493 11.7453 22.3594C11.6924 22.5695 11.5892 22.7635 11.4445 22.9248L11.1774 23.1934C11.0411 23.3287 10.8567 23.4047 10.6646 23.4047C10.4725 23.4047 10.2881 23.3287 10.1518 23.1934L8.56439 21.6076L8.53692 21.577L7.33418 20.3774L7.30365 20.3468L5.71934 18.761C5.584 18.6246 5.50806 18.4403 5.50806 18.2481C5.50806 18.056 5.584 17.8717 5.71934 17.7353L5.98797 17.4667C6.14954 17.3226 6.34371 17.2199 6.55376 17.1675C6.76382 17.1152 6.98345 17.1146 7.19376 17.166L9.40234 17.8345C9.60542 17.4197 9.86424 17.0345 10.1716 16.6898L13.1784 13.6829L12.0398 12.5474L5.55297 8.96357C5.47384 8.92753 5.40506 8.87213 5.353 8.80248C5.30093 8.73283 5.26726 8.65119 5.25509 8.56509C5.24292 8.47899 5.25265 8.39122 5.28337 8.30987C5.31409 8.22852 5.36482 8.15623 5.43086 8.09967L6.30544 7.22509C6.46798 7.08004 6.66239 6.97529 6.87293 6.91934C7.08348 6.86339 7.30424 6.85781 7.51734 6.90304L17.2705 9.55272L17.301 9.56188L20.7902 6.07272C21.3549 5.50493 23.2643 4.51588 23.8321 5.08062C24.3969 5.64841 23.4063 7.5563 22.84 8.12257Z"
                fill="black"
              />
            </svg>
            Flight +
          </div>
          <div class="item">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="29"
              height="33"
              viewBox="0 0 29 33"
              fill="none"
            >
              <path
                d="M3.25781 8.90332V24.6533C3.25781 24.9517 3.37634 25.2378 3.58732 25.4488C3.7983 25.6598 4.08444 25.7783 4.38281 25.7783H15.6328V7.77832H4.38281C4.08444 7.77832 3.7983 7.89685 3.58732 8.10782C3.37634 8.3188 3.25781 8.60495 3.25781 8.90332ZM6.63281 11.1533H12.2578V13.4033H6.63281V11.1533ZM6.63281 15.6533H12.2578V17.9033H6.63281V15.6533ZM6.63281 20.1533H12.2578V22.4033H6.63281V20.1533ZM25.7578 4.40332V24.6533C25.7578 24.9517 25.6393 25.2378 25.4283 25.4488C25.2173 25.6598 24.9312 25.7783 24.6328 25.7783H17.8828V5.52832H12.2578V4.40332C12.2578 4.10495 12.3763 3.8188 12.5873 3.60783C12.7983 3.39685 13.0844 3.27832 13.3828 3.27832H24.6328C24.9312 3.27832 25.2173 3.39685 25.4283 3.60783C25.6393 3.8188 25.7578 4.10495 25.7578 4.40332Z"
                fill="black"
              />
            </svg>
            Hotel
          </div>
        </li>
        <li></li>
        <li>
          <div class="item">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
            >
              <g clip-path="url(#clip0_2152_10732)">
                <path
                  d="M15.4874 8.96171C23.4188 8.96171 22.8328 8.96004 22.955 8.96477C22.8812 8.68192 22.7332 8.4239 22.5263 8.21736L20.3518 6.04286C19.8819 5.57293 19.1605 5.43631 18.5565 5.70309C18.2322 5.84639 17.8457 5.77407 17.5948 5.52321C17.344 5.2724 17.2717 4.88593 17.4149 4.56161C17.6817 3.95774 17.5452 3.23623 17.0751 2.76626L14.9007 0.591754C14.2561 -0.052696 13.2075 -0.0527438 12.563 0.591754L9.84242 3.31229L15.4874 8.96171ZM8.82842 4.32633L4.19304 8.96171H13.4594C13.4426 8.94489 13.088 8.58987 8.82842 4.32633ZM23.4585 16.6337C24.0741 16.3954 24.4878 15.7886 24.4878 15.1239V12.0488C24.4878 11.1373 23.7462 10.3957 22.8347 10.3957H19.4687V24.486H22.8347C23.7462 24.486 24.4878 23.7444 24.4878 22.833V19.7578C24.4878 19.0932 24.0742 18.4864 23.4586 18.2481C23.1279 18.12 22.9057 17.7956 22.9057 17.4408C22.9057 17.0861 23.1279 16.7617 23.4585 16.6337ZM0.109375 12.0488V15.1239C0.109375 15.7886 0.522995 16.3954 1.13857 16.6336C1.46926 16.7617 1.69139 17.0861 1.69139 17.4408C1.69139 17.7956 1.46921 18.12 1.13853 18.2481C0.522947 18.4864 0.109375 19.0932 0.109375 19.7578V22.833C0.109375 23.7444 0.850956 24.486 1.76242 24.486H18.0347V10.3957H1.76242C0.850956 10.3957 0.109375 11.1373 0.109375 12.0488ZM5.12845 13.7308H15.8836V15.1649H5.12845V13.7308ZM5.12845 16.5989H15.8836V18.0329H5.12845V16.5989ZM5.12845 19.4669H15.8836V20.901H5.12845V19.4669Z"
                  fill="black"
                />
              </g>
              <defs>
                <clipPath id="clip0_2152_10732">
                  <rect
                    width="24.3784"
                    height="24.3784"
                    fill="white"
                    transform="translate(0.109375 0.108398)"
                  />
                </clipPath>
              </defs>
            </svg>
            Ticket+
          </div>
          <div class="item">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none">
              <path
                d="M22.84 8.12257L19.3509 11.6117L19.36 11.6423L22.0097 21.3954C22.0551 21.6085 22.0495 21.8293 21.9936 22.0399C21.9376 22.2504 21.8328 22.4448 21.6877 22.6073L20.8131 23.4819C20.7565 23.5479 20.6842 23.5987 20.6029 23.6294C20.5215 23.6601 20.4338 23.6698 20.3477 23.6577C20.2616 23.6455 20.1799 23.6118 20.1103 23.5598C20.0406 23.5077 19.9852 23.4389 19.9492 23.3598L16.3654 16.8729L15.2283 15.7343L12.2214 18.7411C11.8768 19.0487 11.4916 19.3075 11.0767 19.5104L11.7483 21.719C11.7992 21.9295 11.7982 22.1493 11.7453 22.3594C11.6924 22.5695 11.5892 22.7635 11.4445 22.9248L11.1774 23.1934C11.0411 23.3287 10.8567 23.4047 10.6646 23.4047C10.4725 23.4047 10.2881 23.3287 10.1518 23.1934L8.56439 21.6076L8.53692 21.577L7.33418 20.3774L7.30365 20.3468L5.71934 18.761C5.584 18.6246 5.50806 18.4403 5.50806 18.2481C5.50806 18.056 5.584 17.8717 5.71934 17.7353L5.98797 17.4667C6.14954 17.3226 6.34371 17.2199 6.55376 17.1675C6.76382 17.1152 6.98345 17.1146 7.19376 17.166L9.40234 17.8345C9.60542 17.4197 9.86424 17.0345 10.1716 16.6898L13.1784 13.6829L12.0398 12.5474L5.55297 8.96357C5.47384 8.92753 5.40506 8.87213 5.353 8.80248C5.30093 8.73283 5.26726 8.65119 5.25509 8.56509C5.24292 8.47899 5.25265 8.39122 5.28337 8.30987C5.31409 8.22852 5.36482 8.15623 5.43086 8.09967L6.30544 7.22509C6.46798 7.08004 6.66239 6.97529 6.87293 6.91934C7.08348 6.86339 7.30424 6.85781 7.51734 6.90304L17.2705 9.55272L17.301 9.56188L20.7902 6.07272C21.3549 5.50493 23.2643 4.51588 23.8321 5.08062C24.3969 5.64841 23.4063 7.5563 22.84 8.12257Z"
                fill="black"
              />
            </svg>
            Flight +
          </div>
        </li>
      </ul>
    </div>
  </div>
